import { render, staticRenderFns } from "./PortfolioCardV2.vue?vue&type=template&id=31426de2&scoped=true"
import script from "./PortfolioCardV2.vue?vue&type=script&lang=ts&setup=true"
export * from "./PortfolioCardV2.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PortfolioCardV2.vue?vue&type=style&index=0&id=31426de2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31426de2",
  null
  
)

export default component.exports